import { render, staticRenderFns } from "./select-person.vue?vue&type=template&id=590eb186&scoped=true&"
import script from "./select-person.vue?vue&type=script&lang=js&"
export * from "./select-person.vue?vue&type=script&lang=js&"
import style0 from "./select-person.vue?vue&type=style&index=0&id=590eb186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590eb186",
  null
  
)

export default component.exports